import './vendor/bootstrap';
import 'slick-carousel';
import './app/forms';
import './app/homepage';
import './app/map';
import './app/engagement';
import AOS from "aos";

const $ = jQuery;

AOS.init();

if ($('#metiers').length > 0) {
    $('.legend .left .icone').click(function () {
        const i = $(this).data('id');

        $('.legend .right .single').hide();
        $('.legend .right .single[data-id=' + i + ']').css('display','flex');
    });
}

$('.js-hovering').hover(function () {
    const img = $(this).children('img').data('hoverin');
    $(this).children('img').attr('src', img);
}, function () {
    const img = $(this).children('img').data('hoverout');
    $(this).children('img').attr('src', img);
});



// WEBPACK FOOTER //
// ./src/js/bundle.js